/**
 * Astral Moon Magic — explicit reduction rules (Pythagorean).
 * Master numbers 11, 22, 33 are preserved at the final reduction step when enabled.
 * Karmic debt numbers 13, 14, 16, 19 are recorded when they appear before final reduction.
 */

export const MASTER_NUMBERS = new Set([11, 22, 33]);
export const KARMIC_DEBT_MAP = {
  13: '13/4',
  14: '14/5',
  16: '16/7',
  19: '19/1',
};

/**
 * Reduce a positive integer to 1–9, or keep 11/22/33 when keepMaster is true.
 */
export function reduceNumber(n, options = {}) {
  const { keepMaster = true } = options;
  let x = Math.abs(Math.floor(Number(n)));
  if (!Number.isFinite(x) || x === 0) return { value: 0, steps: [], karmicHits: [] };

  const steps = [];
  const karmicHits = [];

  if (keepMaster && MASTER_NUMBERS.has(x)) {
    return { value: x, steps, karmicHits };
  }

  while (x > 9) {
    if (KARMIC_DEBT_MAP[x]) {
      karmicHits.push(KARMIC_DEBT_MAP[x]);
    }
    const s = String(x)
      .split('')
      .reduce((a, d) => a + parseInt(d, 10), 0);
    steps.push({ from: x, to: s });
    x = s;
    if (keepMaster && MASTER_NUMBERS.has(x)) break;
  }

  return { value: x, steps, karmicHits };
}

/**
 * Sum digits of a number string or integer, returning raw sum (before reduction).
 */
export function digitSum(n) {
  const s = String(Math.abs(Math.floor(Number(n))));
  return s.split('').reduce((a, d) => a + parseInt(d, 10), 0);
}

/**
 * Reduce with full transparency (for debugging / advanced views).
 */
export function reduceWithTrail(n, options = {}) {
  return reduceNumber(n, options);
}
